import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Autocomplete, TextField, Button, Paper, Dialog, Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetGrabMutation, useGetSaleReportsMutation } from '../../services/reports';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const API_URI = process.env.REACT_APP_API_URI;

export default function Grab() {
  const [getSaleReports, saleReportsResult] = useGetSaleReportsMutation();
  const [getGrab, grabResult] = useGetGrabMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [selectedRecord, setSelectedRecord] = useState({});
  const [userId, setUserId] = useState(0);
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
        { StockInStore: 0 }
    ]);

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    const uId = JSON.parse(window.localStorage.getItem("user"))?.id;
    setUserId(uId);

    handleGridHeight();

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?.clientHeight || 0) - 72);
  }

  useEffect(() => {
    if(saleReportsResult && saleReportsResult.data){
      const dt = JSON.parse(saleReportsResult.data);
      if(dt && dt.length){
        setDataLoaded(dt);
        getCoumns(dt[0]);
      }
      updatePinnedBottomRow(null, dt);
    }
  }, [saleReportsResult]);

  const getDataView=async()=>{
    const data = await getGrab({"ReportID": 'orders'}).unwrap();
    const dt = JSON.parse(data);
    if(dt && dt.categories){
        setDataLoaded(dt.categories);
        getCoumns(dt.categories[0]);
      }
    // getSaleReports({"ReportID": 'D2CStock', "Code": 0});
    // gridRef.current.setFilterModel(null);
  }

  const exportExcel = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(dataLoaded, { origin: 0 });
    // ws['!cols'] = [
    //   { wch: 20 }, // Column A
    //   { wch: 30 } // Column B
    // ];
    // XLSX.utils.sheet_add_aoa(ws, [
    //   [{v: selectedStore.label||'All' + ' | SELLING RATE', t: "s", s: {font: { bold: true }}}],
    //   ['From', moment(range.from).format('DD-MMM-YY'), '', '', '', 'Number od day'],
    //   ['To', moment(range.to).format('DD-MMM-YY'), '', '', '', moment(range.to).diff(moment(range.from), 'days')]
    // ], { origin: 'A1' });
    // for(var i=0; i<Object.keys(dataLoaded[0]).length; i++){
    //   var cell_address = { c: i, r: 3 };//column, row
    //   var cell_ref = XLSX.utils.encode_cell(cell_address);
    //   ws[cell_ref].s = {// font: { name: "Arial", sz: 14, bold: true, color: { rgb: "000000" } },// alignment: { horizontal: "left", vertical: "center" }
    //     fill: { fgColor: { rgb: "EFEFEF" } },
    //   };
    // }
    
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "D2CStock.xlsx");
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        resizable: true,
        hide: (key == 'CODE' ? true : false),
        cellStyle: () => ((key=="RSP" || key=="StockInWH" || key=="StockInStore" || key=='DiscountCCS')
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="SuggestOrderWH" ? "bold" : ""
        }:null),
        width: (key == "DESC" || key == 'Store' ? 300 : 150),
        cellRenderer: (props) => //(key == "LINK" ? CustomCell(props) : 
          (key=="RSP" || key=="StockInWH" || key=="StockInStore")?new Intl.NumberFormat('en-US').format(props.value)
          : key=='subCategories' ? `` : props.value
      }
    });
    setCoumns(cols);
  }

  const CustomCell = (props) => {
    if(!props.data.CODE || props.data.CODE == '-1')
      return '';
    const handleClick = () => {
      setSelectedRecord(props.data);
    };
    const encodedString = btoa(props.data.CODE);
    return <Button onClick={handleClick}>{props.data.LINK}{encodedString}</Button>;
  };

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let StockInStore = 0;
    if(data)
      data.map(m=>{
        StockInStore += m.StockInStore;
      })
    else
      api.forEachNodeAfterFilter((node) => {
        StockInStore += node.data.StockInStore;
      });

    const emptyClone = Object.fromEntries(
      Object.keys(data?data[0]:{}).map(key => [key, ""])
    );
    setPinnedBottomRowData([{ ...emptyClone, StockInStore: StockInStore }]);
  };

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  return (
    <div style={{padding: '0 10px'}}>
      { saleReportsResult.isLoading && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader'>
          <Button variant="contained" onClick={getDataView}
            sx={{ marginRight: '10px' }}>View</Button>
          <Button variant="contained" onClick={exportExcel}
            sx={{ marginRight: '10px' }}>Export</Button>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </Paper>
      </div>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}